import { render } from "./LastTaken.vue?vue&type=template&id=7fc5a25a&scoped=true"
import script from "./LastTaken.vue?vue&type=script&lang=js"
export * from "./LastTaken.vue?vue&type=script&lang=js"

import "./LastTaken.vue?vue&type=style&index=0&id=7fc5a25a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fc5a25a"]])

export default __exports__